module.exports = __webpack_public_path__ + "img/play.a0486587.svg";